import { useTranslation } from 'react-i18next'
import React from 'react'

import { useRowsActions } from './_actions/rowsActions'
import { useSegments } from '../_load/SegmentsLoader'
import { useTableState } from '../../../../components/tables/MultiSelectTableContext'
import MultiSelectMenu from '../../../../components/tables/MultiSelectMenu'

const MultiRowsActions = () => {
  const list = useSegments()
  const { selecteds, selected } = useTableState()
  const { t } = useTranslation()
  const [menuOptions, loading] = useRowsActions(selected, selecteds)

  return <MultiSelectMenu list={list} loading={loading} options={menuOptions} t={t} disableForceSelection />
}

export default MultiRowsActions
